
import React from "react";
import { useTranslation } from "react-i18next";
import { Platform, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonVariant, CustomButton } from "./components/CustomButton";
import { ModalType, useModalStore } from "./store/modalStore";
import { useCallback } from "react";
import { useNavigation } from "@react-navigation/native";
import { CustomIcon } from "./components/CustomIcon";
import { FULL_WIDTH, HEADER_HEIGHT } from "./shared/constants/dimension";
import { ROUTES } from "./shared/constants/routes";
import { TabNavigationProp } from "./shared/types/RootStackParamList";
import { useThemeSettings } from "./ThemeProvider";
import HomeScreenHeader from "./components/HomeScreenHeader";
import CustomLinearGradient, { GRADIENT_TYPE } from "./components/CustomLinearGradient";
import { usePlatform } from "./providers/PlatformProvider";
import { useNavStore } from "./store/navStore";

function Header() {
    const { t } = useTranslation();
    const { theme } = useThemeSettings();

    const { showWebVersion } = usePlatform();
    const currentRoute = useNavStore((s) =>
      s.history.length ? s.history[s.history.length - 1] : null,
    );
    const setModalShown = useModalStore((state) => state.setModalShown);
    const navigation = useNavigation<TabNavigationProp>();
    const onLogoPress = useCallback(() => {
        navigation.navigate(ROUTES.HOME, { selectedTab: ROUTES.READ });
    }, []);


    if (Platform.OS !== 'web') return null;

    // Hide header on web onboarding screen
    if (currentRoute?.name === ROUTES.WELCOME_ONBOARDING) {
        return null;
    }
    return (
        <CustomLinearGradient gradientType={showWebVersion ? GRADIENT_TYPE.BASE_WEB : GRADIENT_TYPE.BASE} style={{ position: 'relative' }}>
            <View style={[styles.headerContainer, { height: HEADER_HEIGHT }]} >
                <TouchableOpacity onPress={onLogoPress} >
                    <CustomIcon icon="thinko-full" color={theme?.colors?.primary} size={128} />
                </TouchableOpacity>

                <HomeScreenHeader />
                <View style={styles.rightContainer}>
                    {/*  <CustomIcon icon="categories" size={24} isPressable onPress={() => setModalShown(ModalType.CATEGORIES)} /> */}
                    <CustomButton id={ModalType.LANGUAGES}
                        variant={ButtonVariant.TRANSPARENT}
                        icon='translate'
                        onPress={() => setModalShown(ModalType.LANGUAGES)}
                    >{t("screens.language.selected")}
                    </CustomButton>
                    <CustomButton id={ModalType.MENU}
                        variant={ButtonVariant.TRANSPARENT}
                        icon='user'
                        onPress={() => setModalShown(ModalType.MENU)}
                    >{t("screens.profile.title")}
                    </CustomButton>
                </View>
            </View>
        </CustomLinearGradient>
    );
};

const styles = StyleSheet.create({
    headerContainer: {
        flex: 1,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingTop: 20,
        width: FULL_WIDTH,
        padding: 20,
        alignItems: 'center',
        maxHeight: HEADER_HEIGHT,
        paddingHorizontal: 64
    },
    rightContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
    }
});

export default React.memo(Header);